// material-ui

import printtripsheeticon from '../../../assets/images/trip-print.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const PrintTripSheetIcon = () => {
    

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={printtripsheeticon} alt="Exchange Trailer" width="22"  />
    );
};

export default PrintTripSheetIcon;